import { Accordion, AccordionDetails, AccordionSummary, Button, Typography } from '@mui/material'
import React, { useState } from 'react'
import RoutingEmptyState from '../../../../assets/svg/routing/routingEmptyState.svg'
import RoutingRule from '../../../../assets/svg/routing/routingRule.svg'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLess from '@mui/icons-material/ExpandLess';
import CustomButton from '../../../reusableComponents/CustomButton';

function EmptyState({ handleSetupRule }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };
  return (
    <div >
      <div style={{ maxWidth: "834px", textAlign: "center", margin: "0 auto" }}>
        <Typography level="h3" sx={{ fontSize: "32px", color: "#010102EB", fontWeight: 500 }}>Payment Routing</Typography>
        <Typography level="p" sx={{ fontSize: "14px", color: "#4F4D55" }}>
          Payment routing intelligently directs transactions to the most effective payment processor, enhancing success rates and optimizing the payment experience.
        </Typography>

        <div>
          <RoutingEmptyState alt="Routing" className="iconsSize" />,
        </div>

        <div className='containerBorder p-3'>
          <div className='containerBorder p-3 '>
            <div className='d-flex justify-content-between align-items-center '>
              <Typography className='' sx={{ fontSize: "18px", fontWeight: 500 }}>Success Based Configuration</Typography>
              <span className='routeBade'>Default: Active</span>
            </div>
            <Typography className='text-left mt-1' sx={{ fontSize: "14px", color: "#4F4D55" }}>
              All transactions automatically route  to the processor with the highest success rate.
              This approach maximizes transaction approvals and minimizes failures.
              If you wish to deactivate this rule you can do so by creating a new routing rule from options below.
            </Typography>
          </div>
          <Accordion
            expanded={isExpanded}
            sx={{
              width: "100%",
              boxShadow: "none",
              border: "none",
              "&::before": {
                display: "none",
              },
              minHeight: "40px",

            }}
            className="containerBorder mt-2"
          >
            <AccordionSummary
              aria-controls="panel-content"
              id="panel-header"
              sx={{
                "& .MuiAccordionSummary-content": { display: "block" }, "& .MuiAccordionSummary-content.Mui-expanded": {
                  margin: 0,
                },
              }}
            >

              <div className='d-flex justify-content-between align-items-center ' >

                <div className='d-flex justify-content-between align-items-center' style={{ gap: "10px" }}>
                  <RoutingRule width={42} height={42} color='#403E9F' />
                  <Typography className='' sx={{ fontSize: "18px", fontWeight: 500 }}>Custom Rule Configuration</Typography>
                </div>

                <div className='d-flex justify-content-between align-items-center ' style={{ gap: "30px" }} >
                  <Typography
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent accordion toggle
                      handleToggle();
                    }}
                    style={{ textTransform: "none", fontWeight: 600, color: "#403E9F", fontSize: "14px" }}
                  >
                    {isExpanded ? <span> Read Less <ExpandLess /> </span> : <span> Read More  <ExpandMoreIcon />  </span>}

                  </Typography>
                  <CustomButton color={"primary"} text={"Setup Rule"} size={"sm"}
                    variant={"contained"} onClick={handleSetupRule} />
                </div>
              </div>
            </AccordionSummary>

            <AccordionDetails>
              <Typography className='text-left mt-1' sx={{ fontSize: "14px", color: "#4F4D55" }}>
                Direct traffic among processors using advanced logic rules based on multiple <br /> payment parameters.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>
  )
}

export default EmptyState